import QuickNotes from './QuickNotes';

export default QuickNotes;
